interface LastReadBible {
  version: string;
  bookAbbr: string;
  chapter: string;
}

function isSavedBible(obj: unknown): obj is LastReadBible {
  if (obj === null || typeof obj !== "object") {
    return false;
  }
  const version: unknown = Reflect.get(obj, "version");
  const bookAbbr: unknown = Reflect.get(obj, "bookAbbr");
  const chapter: unknown = Reflect.get(obj, "chapter");
  return typeof version === "string" && typeof bookAbbr === "string" && typeof chapter === "string";
}

/** Last bible passage the user was reading, persisted by the reader. */
export function getLastReadBible(): LastReadBible {
  try {
    const saved = localStorage.getItem("last-read-bible");
    if (saved) {
      const parsed: unknown = JSON.parse(saved);
      if (isSavedBible(parsed)) {
        return parsed;
      }
    }
  } catch {
    /* ignore storage or parsing errors */
  }
  return { version: "kjv", bookAbbr: "gen", chapter: "1" };
}
